export { default } from "./Wrapper";



// WEBPACK FOOTER //
// ./src/components/Wrapper/index.js